import AppointmentFormLayout from "../../../pages/settings/Themes/Layouts/AppointmentForm";
import BannerWithTextLayout from "../../../pages/settings/Themes/Layouts/BannerWithText";
import BannerWithMultipleButtons from "../../../pages/settings/Themes/Layouts/BannerWithMultipleButtons";
import CategoryCollection from "../../../pages/settings/Themes/Layouts/CategoryCollection";
import BrandCollection from "../../../pages/settings/Themes/Layouts/BrandCollection";
import DualImageLayout from "../../../pages/settings/Themes/Layouts/DualImageGrid";
import ImageSlideShow from "../../../pages/settings/Themes/Layouts/ImageSlideShow";
import ImageWithTextLayout from "../../../pages/settings/Themes/Layouts/ImageWithText";
import InfluencerCollection from "../../../pages/settings/Themes/Layouts/InfluencerCollection";
import ProductCollectionLayout from "../../../pages/settings/Themes/Layouts/ProductCollection";
import SubCategoryCollection from "../../../pages/settings/Themes/Layouts/SubCategoryCollection";
import VideoCarouselLayout from "../../../pages/settings/Themes/Layouts/VideoCarousel";
import DualImageBanner from "../../../pages/settings/Themes/Layouts/DualImageBanner";
import RichTextLayout from "../../../pages/settings/Themes/Layouts/RichTextLayout";
import BlogCollection from "../../../pages/settings/Themes/Layouts/BlogCollection";
import TestimonialLayout from "../../../pages/settings/Themes/Layouts/TestimonialLayout";
import CarouselLayout from "../../../pages/settings/Themes/Layouts/CarouselLayout";
import Footer from "../../../pages/settings/Themes/Layouts/Footer";
import SplashScreen from "../../../pages/settings/Themes/Layouts//SplashScreen/SplashScreen";
import SellerCollection from "../../../pages/settings/Themes/Layouts/SellerCollection";
import GridCollection from "../../../pages/settings/Themes/Layouts/GridCollection";
import ImageCollection from "../../../pages/settings/Themes/Layouts/ImageCollection";
import Highlights from "../../../pages/settings/Themes/Layouts/Highlights";
import Image from "../../Image";
import "./style.css";

/**
 *Object of all layouts and their respective jsx components
 */
const layouts = {
  ImageSlideShow: ImageSlideShow,
  ImageWithText: ImageWithTextLayout,
  ProductCollection: ProductCollectionLayout,
  BannerWithText: BannerWithTextLayout,
  BannerWithButton: BannerWithTextLayout,
  BannerWithMultipleButtons: BannerWithMultipleButtons,
  VideoCardCarousel: VideoCarouselLayout,
  CategoryCollection: CategoryCollection,
  BrandCollection: BrandCollection,
  SearchResults: ProductCollectionLayout,
  SubCategoryCollection: SubCategoryCollection,
  AppointmentForm: AppointmentFormLayout,
  DualImageBanner: DualImageBanner,
  DualImage: DualImageLayout,
  RichText: RichTextLayout,
  BlogCollection: BlogCollection,
  Testimonial: TestimonialLayout,
  Carousel: CarouselLayout,
  FooterLayout: Footer,
  Splash: SplashScreen,
  SellerCollection: SellerCollection,
  GridCollection: GridCollection,
  InfluencerCollection,
  ImageCollection,
  Highlights,
  Image: Image,
};

/**
 * @param {*} pageIndex
 * @param {*} layoutName
 * @param {*} pagesArray
 */
export const getLayout = (pageIndex, layoutName, pagesArray, selectOptions) => {
  const defaultOption =
    pagesArray[pageIndex] !== "home" && pagesArray[pageIndex] !== "search"
      ? "CURRENT"
      : "ALL";
  if (layoutName === "ProductCollection" || layoutName === "SearchResults") {
    return layouts[layoutName](selectOptions, defaultOption);
  } else if (layoutName === "ContentBlock") {
    return layouts?.["RichText"]();
  } else {
    return layouts[layoutName]();
  }
};
export default getLayout;
